<template>
  <div class="news-list-page">
    <section class="banner">
      <h1>新闻资讯</h1>
      <p>九恒智电官方发布的最新动态或消息，为您提供第一手资讯</p>
    </section>
    <ul class="tab">
      <li :class="{c: curTab === 3}" @click="go(3)">党建工作</li>
      <li :class="{c: curTab === 1}" @click="go(1)">集团资讯</li>
      <li :class="{c: curTab === 2}" @click="go(2)">媒体报道</li>
      <li :class="{c: curTab === 4}" @click="go(4)">行业动态</li>
    </ul>
    <ul class="ctn list" v-loading="loading" v-if="total > 0">
      <li v-for="(item, index) in news" :key="index">
        <a :href="'#/NewsDetail/' + item.id"><img :src="item.thumb"/></a>
        <time>{{ item.created_date }}</time>
        <span v-for="(tag, key) in item.tags" :key="key" @click="goCata(tag)">{{ tag }}</span>
        <h3><a :href="'#/NewsDetail/' + item.id">{{ item.title }}</a></h3>
        <p>{{ item.summary }}</p>
      </li>
     </ul>
     <div class="empty" v-else>
      无数据
     </div>
     <el-pagination
     v-if="total > 0"
      background
      @current-change="getData"
      :page-size="pageSize"
      layout="prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { Pagination } from 'element-ui'
import axios from 'axios'
export default {
  name: 'App',
  data() {
    return {
      news: [],
      pageSize: 10,
      page: 1,
      total: 0,
      curTab: 1,
      loading: true,
    }
  },
  watch: {
    curTab() {
      this.getData()
    }
  },
  components: {
    ElPagination: Pagination
  },
  created() {
    const p = this.$route.params
    if (p.q) {
      const n = ['集团资讯', '媒体报道', '党建工作', '行业动态'].indexOf(p.q)
      this.curTab = n + 1
    } else if (p.ctype) {
      this.curTab = Number(this.$route.params.ctype) || 1
    }
    // eslint-disable-next-line no-debugger
    // debugger
    this.getData()
  },
  methods: {
    getData(n) {
      this.loading = true;
      if (n) this.page = n
      axios.get(`/api/v1/article/list?page_size=${this.pageSize}&page=${this.page}&ctype=` + this.curTab).then(r => {
        this.total = r.data.count
        if (r && r.data && r.data.list) {
          this.news = r.data.list
          this.loading = false;
        }
      })
    },
    go(n) {
      n !== this.curTab && this.$router.push('/NewsList/' + n)
      this.curTab = Number(n)
    },
    goCata(tag) {
      const n = ['新闻资讯', '媒体报道', '党建工作', '行业动态'].indexOf(tag)
      this.curTab = n + 1
      location.href='#/NewsCata/' + tag.replaceAll('#','').trim()
    }
  }
}
</script>
